import React from "react";
import { Snackbar, IconButton } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import {Close, CheckCircleOutline, ErrorOutline} from "@material-ui/icons";
import { Link } from 'react-router-dom';

const CustomSnackbar = ({ open, closeHandler, message, options, linkAction, linkText, newTab = false, stayOpen = false, clickAwayListenerProps = {}, onLinkClick }) => {
  const handleClose = (event, reason) => {
    closeHandler();
  };

  const handleLinkClick = (event) => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  const action = (
    <React.Fragment>
      <IconButton aria-label="close" color="#FFFFFF" onClick={handleClose}>
        <Close />
      </IconButton>
    </React.Fragment>
  );

    const snackbarProps = {
        open: open,
        onClose: handleClose,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        },
        action: action,
        ...(!stayOpen && { autoHideDuration: 2500 }),
        ClickAwayListenerProps: clickAwayListenerProps
    }

  return (
      <>
          {
              open && <Snackbar
                  key={`snack_${new Date()}`}
                  {...snackbarProps}
              >
                  <MuiAlert
                      onClose={handleClose}
                      severity={options?.severity ? options.severity : 'success'}
                      variant="filled"
                      icon={options?.severity === 'warning' || options?.severity === 'error' ? <ErrorOutline /> : <CheckCircleOutline />}
                      key={`alert_${new Date()}`}
                  >
                      {message} {
                      linkAction !== undefined ?
                          (!newTab ?
                              <Link className='white-text' to={linkAction} onClick={handleLinkClick}>{linkText}</Link> :
                              <a className='white-text' href={linkAction} target="_blank" onClick={handleLinkClick}>{linkText}</a>)
                          : null
                  }
                  </MuiAlert>
              </Snackbar>
          }
      </>
  );
}

export default React.memo(CustomSnackbar);